function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import SwitchingTitleComponent from "./switching-title/switching-title-component";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import classnames from "classnames";
import LottieAnimationComponent from "/components/segments/lottie-animtaion/lottie-animation-component";
import { withAbTests } from "/contexts/ab-tests-context";
import { StyledSwitchingTitleWithSignupComponent } from "./switching-title-with-signup-component.scss";
const SUBTITLE_MODE_CLASS = {
    ["mobile"]: "mobile-only",
    ["desktop"]: "desktop-only"
};
class SwitchingTitleWithSignupComponent extends PureComponent {
    render() {
        const { title, mobileTitle, switchingWords, subtitle, signupForm, activeIndex, showSignup, showSubtitle, aboveTheFold, abTests } = this.props;
        const subtitleModeClass = SUBTITLE_MODE_CLASS[showSubtitle];
        let signupFormExt = signupForm;
        if (aboveTheFold) {
            signupFormExt = _object_spread_props(_object_spread({}, signupForm), {
                showDecorations: false
            });
        }
        return /*#__PURE__*/ _jsxs(StyledSwitchingTitleWithSignupComponent, {
            className: classnames("switching-title-with-signup-component", {
                "above-the-fold": aboveTheFold
            }),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: classnames("switching-title-wrapper", `subtitle-${subtitleModeClass}`),
                    children: /*#__PURE__*/ _jsx(SwitchingTitleComponent, {
                        title: title,
                        switchingWords: switchingWords,
                        activeIndex: activeIndex,
                        mobileTitle: mobileTitle,
                        aboveTheFold: aboveTheFold
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: classnames("subtitle-wrapper", subtitleModeClass),
                    children: /*#__PURE__*/ _jsx("h2", {
                        dangerouslySetInnerHTML: {
                            __html: subtitle
                        }
                    })
                }),
                showSignup && /*#__PURE__*/ _jsx("div", {
                    className: "signup-form-with-decorations-wrapper",
                    children: /*#__PURE__*/ _jsx(SignupFormComponent, _object_spread_props(_object_spread({}, signupFormExt), {
                        placement: "switching_words_title",
                        focusOnLoad: true
                    }))
                }),
                aboveTheFold && /*#__PURE__*/ _jsx("div", {
                    className: "arrow-wrapper",
                    children: /*#__PURE__*/ _jsx(LottieAnimationComponent, {
                        aboveTheFold: true
                    })
                })
            ]
        });
    }
}
export default withAbTests(SwitchingTitleWithSignupComponent);
SwitchingTitleWithSignupComponent.defaultProps = {
    title: "A great way to manage your",
    mobileTitle: "A great way to manage your <brand-blue>work</end>",
    subtitle: "Plan, organize and track your work. All in one visual collaborative place",
    switchingWords: {
        wordWidth: "124px",
        words: [
            {
                text: "work",
                color: "brand-red"
            },
            {
                text: "team",
                color: "brand-green"
            },
            {
                text: "leads",
                color: "brand-yellow"
            },
            {
                text: "jobs",
                color: "brand-iris"
            }
        ],
        animationInterval: "1000"
    },
    showSignup: true,
    signupForm: {}
};
